import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var styledLabel = createRuntimeFn({defaultClassName:'label_legacy__1j0yiqp0',variantClassNames:{size:{'default':'label_legacy_styledLabel_size_default__1j0yiqp1',xlarge:'label_legacy_styledLabel_size_xlarge__1j0yiqp2'}},defaultVariants:{},compoundVariants:[]});

export { styledLabel };
//# sourceMappingURL=label_legacy.vanilla.mjs.map
